import type { LiveblocksThread } from './CommentsContext';

export type ThreadDeepLinkAction =
  | { type: 'noop' }
  | { type: 'wait' }
  | { type: 'focus'; threadId: string }
  | { type: 'openCommentsWithoutSelection'; threadId?: string };

export function resolveThreadDeepLink(
  threadIdParam: string | null,
  openCommentsParam: string | null,
  threads: LiveblocksThread[] | undefined,
  isLoading: boolean
): ThreadDeepLinkAction {
  if (!threadIdParam && !openCommentsParam) {
    return { type: 'noop' };
  }

  if (isLoading || !threads) {
    return { type: 'wait' };
  }

  if (threadIdParam) {
    if (threads.some((thread) => thread.id === threadIdParam)) {
      return { type: 'focus', threadId: threadIdParam };
    }
    return { type: 'openCommentsWithoutSelection', threadId: threadIdParam };
  }

  return { type: 'openCommentsWithoutSelection' };
}
